import { State } from 'src/types'
import { webTop, webBottom } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/web'
import { catchFace } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/catchFace'
import { backAroundWeb } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/backAroundWeb'
import { stitch } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/stitch'
import { backOfIndexToLittle } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/backOfIndexToLittle'
import { boomerang } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/boomerang'
import { littleHook } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/littleHook'
import { liningLeather } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/liningLeather'
import { thumbHook } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/thumbHook'
import { laces } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/lace'
import { fingerGuardDrawer } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/fingerGuardDrawer'
import { edgeDrawer } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/edgeDrawer'
import { backOfThumbDrawer } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/thumbDrawer'
import { wristBeltDrawer } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/wristBeltDrawer'
import { liningEmbroidery, thumbEmbroidery } from 'src/features/gorilla/drawer/common/back/embroidery'
import { canvasResetter } from 'src/util/canvas'
import { gorillaLabelHead, gorillaLabelOverAll, gorillaLabelOverAllWithBanana } from 'src/features/gorilla/drawer/labels/gorilla'
import { firstMittChildFingerEmbroidery } from 'src/util/canvas'

export const gorillaCanvasFirstMittBack = (ctx: CanvasRenderingContext2D, state: State): void => {
  if (!state.boomerang) return
  if (!state.thumb) return
  if (!state.underWeb) return
  // リセット
  canvasResetter(ctx)
  // 裏革
  liningLeather(ctx, state.linings.color)
  const isEmbroideryOfLining = state.embroideries.some((x) => x.position.value === 'leatherLiningFirst')
  // 平裏への刺繍
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningFirst'),
      110,
      -65
    )
  }

  const isEmbroideryOfLiningSecond = state.embroideries.some((x) => x.position.value === 'leatherLiningSecond')
  // 平裏への刺繍
  if (isEmbroideryOfLiningSecond) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningSecond'),
      110,
      -25
    )
  }

  // 捕球面
  catchFace(ctx, state.catchFace.color)
  // ウェブ先端側
  webTop(ctx, state.web.color)
  // ウェブ捕球面側
  webBottom(ctx, state.web.color)
  // ブーメラン部分
  boomerang(ctx, state.boomerang.color) // 専用のstateを設けて適用
  // 背面＿人差し指-小指
  backOfIndexToLittle(ctx, state.boomerang.color) // 専用のstateを設けて適用
  // 小指への刺繍
  const isEmbroideryOfChild = state.embroideries.some((x) => x.position.value === 'pinkyFingerSideBack')
  if (isEmbroideryOfChild) {
    firstMittChildFingerEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'pinkyFingerSideBack'),
      -80,
      570
    )
  }

  // 背面＿親指_
  backOfThumbDrawer(ctx, state.thumb.color, state.stitch.color)
  // 手首ベルト
  wristBeltDrawer(ctx, state)

  // 小指掛け紐
  littleHook(ctx, state.littleHook.color)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color)
  // 親指への刺繍
  const isEmbroideryOfThumb = state.embroideries.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryOfThumb) {
    thumbEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -220,
      40,
      -20
    )
  }
  // 背面＿ウェブ周り
  backAroundWeb(ctx, state.underWeb.color)
  // ヘリ革
  edgeDrawer(ctx, state)
  // ステッチ
  stitch(ctx, state.stitch.color)
  // 指カバー
  fingerGuardDrawer(ctx, state.fingerGuardType.value, state.indexCover.color, state.stitch.color)

  // ラベル
  switch (state.gorillaLabel?.value) {
    case 'overAllWappen':
    case 'overAllEmbroidery':
      gorillaLabelOverAll(ctx, 70, 95, 125, 168, 0, 0.9)
      break
    case 'headEmbroidery':
    case 'headWappen':
      // headEmbroidery ,headWappen
      gorillaLabelHead(ctx, 100, 130, 0, 0.85)
      break
    case 'overAllWappen2':
    case 'superMatureKing':
      gorillaLabelOverAllWithBanana(ctx, -20, 30)
  }

  // 革紐
  laces(ctx, state.lace.color)
}
